/* Single article */
document.addEventListener("DOMContentLoaded", () => {
  const articleHeader = document.querySelector(".template-article .article-template__header");

  if (!articleHeader) return;

  const headerElements = document.querySelectorAll(
    ".shopify-section-header, .shopify-section-header .header-wrapper, .shopify-section-header .header-wrapper .header"
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        headerElements.forEach((el) => {
          if (!entry.isIntersecting) {
            el.classList.add("white");
          } else {
            el.classList.remove("white");
          }
        });
      });
    },
    {
      root: null,
      threshold: 0,
      rootMargin: "-1px 0px 0px 0px"
    }
  );

  observer.observe(articleHeader);
});

/* Wishlist */
document.addEventListener("click", (e) => {
  const text = e.target.closest(".card__quick-add-wishlist-text");
  if (!text) return;

  const wrap = text.closest(".card__quick-add-wishlist");
  if (!wrap) return;

  const heartBtn = wrap.querySelector(".wishlist-hero-custom-button button");
  if (!heartBtn) return;

  heartBtn.click();
});

/* Product recommendations swiper */
window.addEventListener("load", () => {
  setTimeout(() => {
    document.querySelectorAll(".js-recommendation-swiper").forEach((el) => {
      const slides = el.querySelectorAll(".swiper-slide");

      if (slides.length <= 2 && el.swiper) {
        el.swiper.destroy(true, true);
      }
    });
  }, 50);
});